const CMS_CONFIG = {
    GUJARATI: 'gujaraticms.news18.com',
    TAMIL: 'tamilcms.news18.com',
    PUNJABI: 'punjabicms.news18.com',
    TELUGU: 'telugucms.news18.com',
    IBNLIVE: 'cms.ibnlive.com',
    FIRSTPOST: 'cms.firstpost.com',
    MALAYALAM: 'malayalamcms.news18.com',
    ODIA: 'odiacms.news18.com',
    ASSAM: 'assamcms.news18.com',
    KANNADA: 'kannadacms.news18.com',
    URDU: 'urducms.pradesh18.com',
    MARATHI: 'cms.news18marathi.com',
    BENGALI: 'bengalicms.pradesh18.com',
};

export default CMS_CONFIG;

export const VALID_STATES = ["TRANSLATED","DISCARDED", "PUBLISHED", "DRAFT", "USED", "REGENERATED"]
 